<template>
  <div class="analytics-page">
    <!-- 页面标题 -->
    <div v-if="false" class="page-header">
      <a-page-header :title="pageTitle" :sub-title="pageSubTitle" @back="handleBack">
        <template #extra>
          <a-space>
            <a-button @click="handleReset"> <a-icon type="undo" />重置 </a-button>
            <a-button type="primary" @click="handleSave"> <a-icon type="save" />保存配置 </a-button>
          </a-space>
        </template>
      </a-page-header>
    </div>

    <!-- 内容区域 -->
    <div class="page-content">
      <!-- 筛选器区域 -->
      <a-card :bordered="false" class="filter-card" size="small">
        <analytics-filter ref="analyticsFilter" @query="handleQuery" />
      </a-card>

      <!-- 图表区域 -->
      <a-card :bordered="false" class="chart-card" :loading="loading" size="small">
        <analytics-chart ref="analyticsChart" :title="chartTitle" :analysis-data="analysisData" />
      </a-card>
    </div>

    <!-- 保存配置抽屉 -->
    <a-drawer title="保存分析配置" :visible="drawerVisible" width="400" @close="drawerVisible = false">
      <a-form :form="form" layout="vertical">
        <a-form-item label="配置名称">
          <a-input placeholder="请输入配置名称" />
        </a-form-item>
        <a-form-item label="配置描述">
          <a-textarea v-decorator="['description']" :rows="4" placeholder="请输入配置描述" />
        </a-form-item>
      </a-form>
      <div class="drawer-footer">
        <a-button style="margin-right: 8px" @click="drawerVisible = false"> 取消 </a-button>
        <a-button type="primary" @click="saveConfig"> 确定 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { trackEventAnalysis } from '@/api/system/track';
import AnalyticsFilter from './components/AnalyticsFilter.vue';
import AnalyticsChart from './components/AnalyticsChart.vue';

export default {
  name: 'AnalyticsPage',
  components: {
    AnalyticsFilter,
    AnalyticsChart
  },
  data() {
    return {
      pageTitle: '数据分析',
      pageSubTitle: '查看和分析数据趋势',
      chartTitle: '数据趋势',
      chartType: 'line',
      loading: false,
      drawerVisible: false,
      form: this.$form.createForm(this),
      currentQuery: null,
      analysisData: {}
    };
  },
  beforeDestroy() {
    // 清理表单
    this.form.resetFields();
  },
  methods: {
    // 处理查询
    handleQuery(filters) {
      trackEventAnalysis({ ...filters }).then(res => {
        this.analysisData = res.data;
      });
    },

    // 重置筛选条件
    handleReset() {
      this.$refs.analyticsFilter.$emit('reset');
      this.$refs.analyticsChart.refreshData();
    },

    // 返回上一页
    handleBack() {
      this.$router.go(-1);
    },

    // 打开保存配置抽屉
    handleSave() {
      this.drawerVisible = true;
    },

    // 保存配置
    saveConfig() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const config = {
            ...values,
            queryParams: this.currentQuery,
            createTime: new Date().toISOString()
          };

          console.log('Save config:', config);
          this.$message.success('保存成功');
          this.drawerVisible = false;
          this.form.resetFields();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.analytics-page {
  background: #f0f2f5;
  min-height: 100vh;

  .page-header {
    background: #fff;
    padding: 16px 32px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }

  .filter-card {
    margin-bottom: 24px;
  }

  .chart-card {
    min-height: 500px;
  }

  .drawer-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
  }
}

@media screen and (max-width: 768px) {
  .analytics-page {
    .page-content {
      padding: 12px;
    }

    .filter-card,
    .chart-card {
      margin-bottom: 12px;
    }
  }
}
</style>
